//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscMic(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V15H16V6ZM14 13H10V6C10 4.9 10.9 4 12 4C13.1 4 14 4.9 14 6V13Z" fill="currentColor" /><path d="M18 11V14.76C18 16 17 17 15.76 17H8.24C7 17 6 16 6 14.76V11H4V14.76C4 17.1 5.9 19 8.24 19H11V22H13V19H15.76C18.1 19 20 17.1 20 14.76V11H18Z" fill="currentColor" /></svg>;
}
export default IconMiscMic;